import React, { useEffect, useRef, useState } from 'react'
import HeaderIcon from '../../../assets/images/header-icon/croucki-info.png'
import Input from '../../master/Input'
import Switch from '../../master/Switch'
import { hardCopy, pexios, uploadImages } from '../../../utils/functions';
import SearchablePicker from '../../master/SearchablePicker';
import { useSelector } from 'react-redux';
import ImageBox from '../../master/ImageBox';
import { t } from 'i18next';

function CrouckiInfo({data,changeData,changeStep,btnLoading}) {
    const [coroukieTypes,setCorouckieTypes] = useState([]);
    // const [attachments,setAttachments] = useState([])
    // const {routerData , accidentInfo,insuranceCode,user} = useSelector((store) => store);
    // const id = routerData?.id;
    const form = useRef(null);
    // const coroukie_images = attachments.filter(itm => itm.filename.includes('coroukie_image'))
    useEffect(() => {
        pexios('api/get_coding_data/coroukie')
            .then(res => {
                setCorouckieTypes([...res.data]);
            });
    }, []);
    // function uploadDoc(image, name, done) {
    //         let copy_attachments = hardCopy(attachments);
    //         const index = copy_attachments.findIndex(img => img.filename === name);
    //         uploadImages({
    //             id,
    //             type: 'accident',
    //             name,
    //             image,
    //             done,
    //             callback: (data) => {
    //                 if (index !== -1) copy_attachments[index] = data;
    //                 else copy_attachments.push(data);
    //                 // setAccident(prevState => ({
    //                 //     ...prevState,
    //                 //     attachments,
    //                 // }));
    //                 setAttachments(copy_attachments)
    //             },
    //         });
    //     }
  return (
    <div>
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        <p className='guide-text mx10 mt10'>
        درصورتی که هرگونه گزارشی اعم از کروکی و یا سایر گزارشات دارید اطلاعات مربوطه را در این قسمت وارد نمایید.
        </p>
        {/* <div className='d-flex mb10 mt20 mr10' style={{direction: "rtl"}}>
            <label className='custom-checkbox' style={{marginTop:'3px'}}>
                <input type='checkbox' checked={data.has_croucki} onChange={(e) => changeData(e.target.checked,'has_coroukie')}/>
                <span className='checkmark'/>
            </label>
            <p className='mr25 guide-text'> کروکی دارم</p>
        </div> */}
        <div className='col-12 row align-items-center'>
            <label className='pr10 pt10 pl10' style={{fontSize:'14px'}}>کروکی دارم ؟</label>
            <Switch
                value={data.has_coroukie}
                onChange={(value) =>changeData(value,'has_coroukie')}
            />
        </div>
        {data.has_coroukie &&
            <div className='row text-right' ref={form}>
                <SearchablePicker 
                    label='نوع گزارش'
                    value={data.coroukie_type}
                    data={coroukieTypes}
                    titleKey='title'
                    valueKey='id'
                    onSelect={value => changeData(value, 'coroukie_type')}
                    col={12}
                    rtl
                    required={data.has_coroukie}
                />
                <Input
                    label='نام مامور گزارش'
                    value={data.coroukie_agent}
                    onChange={value => changeData(value, 'coroukie_agent')}
                    name='fname'
                />
                <Input
                    label='کد مامور گزارش'
                    value={data.coroukie_agent_code}
                    onChange={value => changeData(value, 'coroukie_agent_code')}
                />
                <Input
                    label='سریال گزارش'
                    value={data.coroukie_serial}
                    onChange={value => changeData(value, 'coroukie_serial')}
                />
                <Input
                    label='سری گزارش'
                    value={data.coroukie_serie}
                    onChange={value => changeData(value, 'coroukie_serie')}
                />
                
            </div>
        }
        {/* {data.has_coroukie &&
        <div className='complete mt20'>
            <div className='d-flex flex-row-reverse flex-wrap'>
                {coroukie_images.length > 0 && coroukie_images.map(itm=>(
                    <ImageBox
                        title={t('Police Report')}
                        name={`${itm.filename}`}
                        label='croukie_image'
                        attachments={attachments}
                        uploadDoc={uploadDoc}
                    />
                ))}
                <ImageBox
                    title={t('Police Report')}
                    name={`coroukie_image${coroukie_images.length +1}`}
                    label='croukie_image'
                    attachments={attachments}
                    uploadDoc={uploadDoc}
                />
            </div>
        </div>
        } */}
        <div className='group-btn mt30'>
            <button className={`btn btn-circle btn-block btn-orange btn-bold`} onClick={()=>changeStep('prev')}>
                مرحله قبل
            </button>
            <button 
                className={`btn btn-circle btn-block btn-white-purple btn-bold`} 
                onClick={()=>changeStep('next',form)}
                disabled={btnLoading}
                >
                    {btnLoading ? <i className='fas fa-spinner fa-spin' />:' مرحله بعد'}
            </button>
            
        </div>
    </div>
  )
}

export default CrouckiInfo